import { GetThePhoneCallCallerNameForAnIdoAndInstanceQueryReturn } from 'src/models/ido';

import { Callback } from 'src/util/query/models/Callback';

import { SetThePhoneCallCallerNameForAnIdoAndInstancePayload } from '../interfaces';

export class GetThePhoneCallCallerNameForAnIdoAndInstanceQueryCallback extends Callback<GetThePhoneCallCallerNameForAnIdoAndInstanceQueryReturn> {
	public constructor(
		private readonly idoRecordIdentifierOrAggregateId: string,
		private readonly setThePhoneCallCallerNameForAnIdoAndInstance: (
			payload: SetThePhoneCallCallerNameForAnIdoAndInstancePayload
		) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: GetThePhoneCallCallerNameForAnIdoAndInstanceQueryReturn): void => {
		this.setThePhoneCallCallerNameForAnIdoAndInstance({
			callerName: successResponse.callerName,
			idoRecordIdentifierOrAggregateId: this.idoRecordIdentifierOrAggregateId,
		});
	};
}
